import React, { ReactNode } from 'react';
import get from 'lodash/get';
import { useConfirm } from 'material-ui-confirm';
import { FormattedMessage } from 'react-intl';

import { Switch } from '@mui/material';

import { useSelector, useDispatch } from '../store/utils';
import { variablesChange } from '../store/actions';
import { VariableId } from '../store/types';
import { useVisibility, VisibilityProps } from '../store/use-visibility';

import { ControlBox, ControlBoxProps } from '../atoms/control-box';

type Props = {
  switchVariableId?: VariableId;
  lock?: {
    when: VisibilityProps['visibility'];
    title?: ReactNode;
    description?: ReactNode;
  };
} & ControlBoxProps;

export const SwitchBox = ({ switchVariableId, lock, ...props }: Props) => {
  const switchValue = useSelector((s) =>
    switchVariableId ? get(s.variables, switchVariableId) : undefined
  );
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const lockConditionMet = useVisibility(lock?.when);
  const isLocked = lock !== undefined && lockConditionMet;

  return (
    <ControlBox
      control={
        <>
          {switchVariableId && (
            <Switch
              checked={Boolean(switchValue)}
              onChange={(_e, v) => {
                if (isLocked) {
                  return confirm({
                    title: lock.title,
                    description: lock.description,
                    confirmationText: (
                      <FormattedMessage id="close" defaultMessage="Zavřít" />
                    ),
                    hideCancelButton: true,
                  })
                    .then(() => {
                      // noop
                    })
                    .catch(() => {
                      // noop
                    });
                }

                dispatch(variablesChange({ [switchVariableId]: Boolean(v) }));
              }}
            />
          )}
        </>
      }
      {...props}
    />
  );
};
